import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import QuestionContent from "../components/QuestionContent.vue";
import { fetchPaperDetail } from "@/api/test-paper";
import { AppModule } from "@/store/modules/app";
let TestPaperPreview = class TestPaperPreview extends Vue {
    constructor() {
        super(...arguments);
        this.paperDetail = {};
        this.qesList = [];
        this.isShowGlobalLoading = false;
        this.loading = false;
    }
    get isSidebarExpanded() {
        return AppModule.sidebar.opened;
    }
    created() {
        console.log("进入到预览页面");
        const paperId = this.$route.query.paper_id;
        const callback = (paper) => {
            console.log("这是什么data呀？？？");
            this.paperDetail = paper;
            this.qesList = paper.questionList || [];
        };
        this.getPaperDetails(paperId, callback);
    }
    async getPaperDetails(paperId, callback) {
        this.loading = true;
        try {
            const res = await fetchPaperDetail(paperId);
            this.$message.success("获取试卷信息成功");
            callback(res.data.data);
        }
        catch (_) { }
        finally {
            this.loading = false;
        }
    }
    exitPreview() {
        this.$router.push({ name: "TestPaper" });
    }
};
TestPaperPreview = tslib_1.__decorate([
    Component({
        name: 'TestPaperPreview',
        components: {
            QuestionContent
        }
    })
], TestPaperPreview);
export default TestPaperPreview;
